module.exports = __webpack_public_path__ + "h5/img/memberTv.07f6eb65.png";